import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import { pdf } from '@react-pdf/renderer';

/**
 * Abre um pdf em uma nova aba a partir de um componente jsx.
 * @param documentComponent Documento.
 */
export const exportFromJsxToPdf = async (documentComponent?: JSX.Element) => {
  if (!documentComponent)
    return;

  const blob = await pdf(documentComponent).toBlob();
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
};

/**
 * Gera um pdf em uma nova aba recebendo colunas e linhas.
 * @param collumns Colunas.
 * @param rows Linhas.
 * @param title Título opcional.
 */
export const exportFromArrayToPdf = (collumns: string[], rows: string[][], title?: string) => {

  const doc = new jsPDF();

  if (title) {
    doc.text(title, 14, 10);
  }

  autoTable(doc, {
    head: [collumns],
    body: rows,
  });
  const blobUrl = doc.output("bloburl");
  window.open(blobUrl, "_blank");
};


export const exportFromTableToPdf = (
  htmlTableId: string,
  htmlHeaders: string[],
  orientation: "p" | "portrait" | "l" | "landscape" = "p",
  unit: "pt" | "px" | "in" | "mm" | "cm" | "ex" | "em" | "pc" = "pt",
  format: string | number[] = "a4",
  skipPages: number = 0 // número de páginas iniciais a NÃO numerar (ex.: capa = 1)
) => {
  const doc = new jsPDF(orientation, unit, format);

  // Se precisar habilitar uma capa futuramente.
  // if (title) {
  //   doc.setFontSize(20);
  //   doc.text(title, (doc.internal.pageSize as any).getWidth() / 2, 100, { align: "center", });
  //   doc.setFontSize(12);
  //   doc.text("Gerado em: " + new Date().toLocaleString(), (doc.internal.pageSize as any).getWidth() / 2, 120, { align: "center" });
  //   doc.addPage();
  // }

  autoTable(doc, {
    html: `#${htmlTableId}`,
    margin: { top: 40 * htmlHeaders.length, bottom: 40 },
    didDrawPage: (data) => {
      doc.setFontSize(12);
      if (htmlHeaders)
        doc.text(htmlHeaders, data.settings.margin.left, 30);
    },
  });

  const totalPages: number =
    typeof (doc as any).getNumberOfPages === "function"
      ? (doc as any).getNumberOfPages()
      : (doc as any).internal?.getNumberOfPages?.() ?? 1;

  const ps = doc.internal.pageSize as any;
  const pageHeight = ps.height ? ps.height : ps.getHeight();
  const pageWidth = ps.width ? ps.width : ps.getWidth();

  // percorre todas as páginas e escreve o footer com o número correto
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);

    const displayNumber = i - skipPages;
    const displayTotal = totalPages - skipPages;

    if (displayNumber > 0) {
      doc.setFontSize(10);
      const pTop = pageHeight - 20;
      const pLeft = 40;
      const pCenter = (doc.internal.pageSize as any).getWidth() / 2;
      const pright = pageWidth - 40

      doc.text("SGI - Sistema de Gestão Interna.", pLeft, pTop, { align: "left" });
      doc.text(`Página ${displayNumber} de ${displayTotal}`, pCenter, pTop, { align: "center" });
      doc.text("Gerado em: " + new Date().toLocaleString(), pright, pTop, { align: "right" });
    }
  }

  const blobUrl = doc.output("bloburl");
  window.open(blobUrl, "_blank");
};

